import { useContext, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";
import Cookies from "js-cookie";

import Home from "../pages/home";
import SignIn from "../pages/signin";
import Main from "../components/generic/main";
import Dashboard from "../pages/dashboard";
import React from "react";
import Permission from "../pages/permission";
import Clients from "../pages/clients";
import Users from "../pages/users";
import Profile from "../pages/profile";
import EditPassword from "../pages/editPassword";
import NotPermission from "../pages/notpermission";
import Synchronize from "../pages/sync";
import Logs from "../pages/logs";
// import PDFReader from './components/PDFReader';
import { PDFViewer } from "@react-pdf/renderer";
import PreviewPdfEstatiscAnalitic from "../pages/previewEstatisticoAnalitico";
import PreviewPdfEstatisc from "../pages/previewEstatistico";
import Dashboard2 from "../pages/dashboard/page";
import Pdf from "../pages/dashboard/templates/pdf";

export default function RoutesApp() {
  const token = Cookies.get("projetomodelo.token");
  const { isAuthenticated, signOut, user } = useContext(AuthContext);

  useEffect(() => {
    if (!isAuthenticated && !token) signOut();
  }, [isAuthenticated]);

  // const { chart, handleDash1 } = useContext(PdfDashboardContext)

  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      {isAuthenticated && token ? (
        <>
          <Route
            path="/home"
            element={
              <Main name="Home">
                <Home />
              </Main>
            }
          />
          <Route
            path="users/:id"
            element={
              <Main name="Configurações">
                <Users />
              </Main>
            }
          />
          <Route
            path="/dashboard2"
            element={
              <Main name="Dashboard">
                <Dashboard />
              </Main>
            }
          />
          <Route
            path="/dashboard"
            element={
              <Main name="Dashboard">
                <Dashboard2 />
              </Main>
            }
          />
          <Route
            path="/permission"
            element={
              <Main name="Configurações">
                <Permission />
              </Main>
            }
          />
          <Route
            path="/clients"
            element={
              <Main name="Configurações">
                <Clients />
              </Main>
            }
          />
          <Route
            path="/synchronize"
            element={
              <Main name="Sincronização">
                <Synchronize />
              </Main>
            }
          />
          <Route
            path="/users"
            element={
              <Main name="Configurações">
                <Users />
              </Main>
            }
          />
          <Route
            path="/profile"
            element={
              <Main name="Perfil">
                <Profile />
              </Main>
            }
          />
          <Route
            path="/previewPdfAnalitics"
            element={
                <PreviewPdfEstatiscAnalitic/>
                // <Pdf/>
            }
          />
          <Route
            path="/previewPdf"
            element={
                <PreviewPdfEstatisc/>
            
            }
          />
          <Route
            path="/editPassword"
            element={
              <Main name="Perfil">
                <EditPassword />
              </Main>
            }
          />
          <Route
            path="/logs"
            element={
              <Main name="Logs">
                <Logs />
              </Main>
            }
          />
          {/* <Route path="*" element={<NotPermission />} /> */}
        </>
      ) : null}
      <Route path="*" element={<SignIn />} />
    </Routes>
  );
}
